import { callApi } from './api'

export function login (credentials) {
  const {
    email,
    password
  } = credentials

  const endpoint = 'sessions/users'
  const config = {
    method: 'POST',
    body: {
      email,
      password
    }
  }

  return callApi(endpoint, config)
}

export function fbLogin (payload) {
  const {
    expiresAt,
    token,
    uid
  } = payload

  const endpoint = 'sessions/oauth'
  const body = {
    provider: 'facebook',
    expiresAt,
    token,
    uid
  }
  const config = {
    method: 'POST',
    body
  }

  return callApi(endpoint, config)
}

export function signup (credentials) {
  const {
    firstName,
    lastName,
    email,
    phone,
    password,
    passwordConfirmation
  } = credentials

  const endpoint = 'registro'
  const config = {
    method: 'POST',
    body: {
      user: {
        firstName,
        lastName,
        email,
        phone,
        password,
        passwordConfirmation
      }
    },
    removeVersionFromUrl: true
  }

  return callApi(endpoint, config)
}



// WEBPACK FOOTER //
// ./src/services/api/auth.js